<template>
    <div class="main-wrapper">
        <BHeader :title="$t('common.entusrNew')"/>
        <div class="form-list" align="left">
            <div>
                <label>{{$t("usrinquire.comNm")}}<text style="color:red">（必須）</text></label>
                <BFormInput type="text" v-model="model.comNm" :class="feedback.comNm != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.comNm}}</div>
            </div>
            <div>
                <label>{{$t("assentusrnew.location")}}</label>
                <BFormInput type="text" v-model="model.comAdr" :class="feedback.comAdr != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.comAdr}}</div>
            </div>
            <div>
                <label>氏名<text style="color:red">（必須）</text></label>
                <BFormInput type="text" v-model="model.usrNm" :class="feedback.usrNm != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.usrNm}}</div>
            </div>
            <div>
                <label>{{$t("assentusrnew.usrNmKna")}}</label>
                <BFormInput type="text" v-model="model.appUsrKna" :class="feedback.appUsrKna != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.appUsrKna}}</div>
            </div>
            <div>
                <label>{{$t("assentusrnew.deploy")}}</label>
                <BFormInput type="text" v-model="model.appUserDepNm" :class="feedback.appUserDepNm != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.appUserDepNm}}</div>
            </div>
            <div>
                <label>役職</label>
                <BFormInput type="text" v-model="model.appPost" :class="feedback.appPost != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.appPost}}</div>
            </div>
            <div>
                <label>電話番号<text style="color:red">（必須）</text></label>
                <BFormInput type="text" v-model="model.appUsrTel" :class="feedback.appUsrTel != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.appUsrTel}}</div>
            </div>
            <div>
                <label>Ｅｍａｉｌアドレス(1)<text style="color:red">（必須）</text></label>
                <BFormInput type="text" v-model="model.usrMlAdr" :class="feedback.usrMlAdr != '' ? 'error-border':''"/>
                <div class="feedback">{{feedback.usrMlAdr}}</div>
            </div>
        </div>
        <button @click="jump()">{{$t("assEntusr.to_popenvironment")}}</button>
    </div>
</template>
<script>
import BHeader from '@/views/header.vue'
import { ref,onMounted,inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { email } from '../../utils/validate_cont.js'

export default {
    components:{
        BHeader
    },
    setup(){
        const service = inject("service")
        const login = JSON.parse(sessionStorage.getItem("login"))
        const { t } = useI18n()
        const router = useRouter()
        const model = ref({
            comNm: '',
            comAdr: '',
            usrNm: '',
            appUsrKna: '',
            appUserDepNm: '',
            appPost: '',
            appUsrTel: '',
            usrMlAdr: '',
        })
        const feedback = ref({
            comNm: '',
            comAdr: '',
            usrNm: '',
            appUsrKna: '',
            appUserDepNm: '',
            appPost: '',
            appUsrTel: '',
            usrMlAdr: '',
        })
        onMounted(()=>{
            if (!login) {
                router.push({ name: 'login'})
                return;
            }
            service.assentusr.assentusr.editNew(login).then(res => {
                model.value = res
            }).catch(error => {
                console.log(error)
            })
        })
        
        async function confirm(){
            let count = 0
            let totalCount = 8
            if(model.value.comNm == '' || model.value.comNm== null){
                feedback.value.comNm = t("message.enter_required_verb",{name:t("usrinquire.comNm")})
            }else if(model.value.comNm.length>60){
                feedback.value.comNm = t("message.enter_length_verb",{name:t("usrinquire.comNm"),number:60})
            }else if(!/^[^ -~｡-ﾟ]*$/.test(model.value.comNm)){
                feedback.value.comNm = t("message.full_verb",{name:t("usrinquire.comNm")})
            }else{
                const validateData = { invalidStr: model.value.comNm,isUnicoe:true }
                await service.invalid.invalid.validate(validateData).then(res => {
                    feedback.value.comNm = ''
                    count++
                }).catch((error) => {
                    feedback.value.comNm = t("usrinquire.comNm")+ error.message
                })
            }

            if(model.value.comAdr.length>250){
                feedback.value.comAdr = t("message.enter_length_verb",{name:t("assentusrnew.location"),number:250})
            }else if(!/^[^ -~｡-ﾟ]*$/.test(model.value.comAdr)){
                feedback.value.comAdr = t("message.full_verb",{name:t("assentusrnew.location")})
            }else{
                const validateData = { invalidStr: model.value.comAdr,isUnicoe:true,isAddress:true }
                await service.invalid.invalid.validate(validateData).then(res => {
                    feedback.value.comAdr = ''
                    count++
                }).catch((error) => {
                    feedback.value.comAdr = t("assentusrnew.location")+ error.message
                })
            }

            if(model.value.usrNm == '' || model.value.usrNm== null){
                feedback.value.usrNm = t("message.enter_required_verb",{name:'氏名'})
            }else if(model.value.usrNm.length>30){
                feedback.value.usrNm = t("message.enter_length_verb",{name:'氏名',number:30})
            }else if(!/^[^ -~｡-ﾟ]*$/.test(model.value.usrNm)){
                feedback.value.usrNm = t("message.full_verb",{name:'氏名'})
            }else{
                const validateData = { invalidStr: model.value.usrNm,isUnicoe:true }
                await service.invalid.invalid.validate(validateData).then(res => {
                    feedback.value.usrNm = ''
                    count++
                }).catch((error) => {
                    feedback.value.usrNm = '氏名'+ error.message
                })

            }

            if(model.value.appUsrKna != '' && model.value.appUsrKna != null){
                if(model.value.appUsrKna.length>60){
                feedback.value.appUsrKna = t("message.enter_length_verb",{name:t("assentusrnew.usrNmKna"),number:60})
                }else if(!/^[\u30A0-\u30FF\uFF65-\uFF9F\uFF10-\uFF19\uFF0D\u3000\uFF08\uFF09\uFF65]+$/.test(model.value.appUsrKna)){
                    feedback.value.appUsrKna = t("message.full_verb",{name:t("assentusrnew.usrNmKna")})
                }else{
                    feedback.value.appUsrKna = ''
                    count++
                }
            }else{
                feedback.value.appUsrKna = ''
                count++
            }
            if(model.value.appUserDepNm.length>60){
                feedback.value.appUserDepNm = t("message.enter_length_verb",{name:t("assentusrnew.deploy"),number:60})
            }else if(!/^[^ -~｡-ﾟ]*$/.test(model.value.appUserDepNm)){
                feedback.value.appUserDepNm = t("message.full_verb",{name:t("assentusrnew.deploy")})
            }else{
                const validateData = { invalidStr: model.value.appUserDepNm,isUnicoe:true }
                await service.invalid.invalid.validate(validateData).then(res => {
                    feedback.value.appUserDepNm = ''
                    count++
                }).catch((error) => {
                    feedback.value.appUserDepNm  = t("assentusrnew.deploy")+ error.message
                })
            }
            if(model.value.appPost.length>20){
                feedback.value.appPost = t("message.enter_length_verb",{name:'役職',number:20})
            }else if(!/^[^ -~｡-ﾟ]*$/.test(model.value.appPost)){
                feedback.value.appPost = t("message.full_verb",{name:'役職'})
            }else{
                const validateData = { invalidStr: model.value.appPost,isUnicoe:true }
                await service.invalid.invalid.validate(validateData).then(res => {
                    feedback.value.appPost = ''
                    count++
                }).catch((error) => {
                    feedback.value.appPost  = '役職'+ error.message
                })
            }
            if(model.value.appUsrTel == '' || model.value.appUsrTel== null){
                feedback.value.appUsrTel = t("message.enter_required_verb",{name:'電話番号'})
            }else if(!(/^[0-9]+\-{0,1}[0-9]+\-{0,1}[0-9]+$/.test(model.value.appUsrTel))){
                feedback.value.appUsrTel = "電話番号は電話番号の形式(例 11-1111-1111)で入力してください。"
            }else if(model.value.appUsrTel.length > 32){
                feedback.value.appUsrTel = "電話番号は32文字以内で入力してください。"
            }else{
                feedback.value.appUsrTel = ''
                count++
            }
            if(model.value.usrMlAdr == '' || model.value.usrMlAdr == null){
                feedback.value.usrMlAdr = "Emailアドレス(1)を入力してください。"
            }else if(model.value.usrMlAdr.length > 128){
                feedback.value.usrMlAdr = "Emailアドレス(1)は128文字以内で入力してください。"
            }else if(!(/^(.+)@(.+)$/.test(model.value.usrMlAdr))){
                feedback.value.usrMlAdr = "Emailアドレス(1)は Email の形式(例 XXXXXXX{'@'}XX.com)で入力してください。"
            } else {
                //RFCメール検証
                const validateData = { invalidStr: model.value.usrMlAdr };
                const validationResult = await email(validateData);
                if (validationResult.code === 201) {
                    feedback.value.usrMlAdr = "RFC違反のメールアドレスの為、登録できません。";
                } else if (validationResult.code === 200) {
                    feedback.value.usrMlAdr = ''
                    count++
                }
                
            }

            return count == totalCount? true : false
        }
        async function jump(){
            const sendData = { updData: model.value, login }
            if(! await confirm()){
                return
            } else {
                service.assentusr.assentusr.create(sendData).then(res => {
                    router.push({ name: 'Popenvironment',params:{showBtn: true}})
                }).catch(error => {
                    console.log(error)
                })
            }
        }
        return{
            model,
            feedback,
            jump
        }
    }
}
</script>
<style lang="scss" scoped>
    .main-wrapper{
        margin: 57px 0px 48px;
        padding: 0px 32px;
        .form-list{
            label{
                font-weight: 600;
                font-size: 13px;
                line-height: 18px;
                color: #30353B;
                margin-bottom: 4px;
            }
            .form-control{
                padding: 7px 8px;
                background: #FFFFFF;
                border: 1px solid #A8B0BB;
                border-radius: 3px;
                font-weight: 300;
                font-size: 16px;
                line-height: 21px;
                color: #30353B;
                &:focus{
                    box-shadow: none;
                    border-color: #2394F7;
                }
            }
            .feedback{
                margin-top: 4px;
                font-weight: 300;
                font-size: 12px;
                line-height: 16px;
                color: #EE4967;
            }
        }
        button{
            margin-top:24px;
            width:100%;
            background: #2394F7;
            border-radius: 4px;
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            color: #FFFFFF;
            height: 40px;
            padding: 8px 16px;
            border: none;
        }
    }
</style>
